var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5 10H25C25.6904 10 26.25 10.5596 26.25 11.25V13.75C26.25 14.4404 25.6904 15 25 15H5C4.30964 15 3.75 14.4404 3.75 13.75V11.25C3.75 10.5596 4.30964 10 5 10Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#B45AFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15 10V26.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#B45AFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.75 15V23.75C23.75 24.413 23.4866 25.0489 23.0178 25.5178C22.5489 25.9866 21.913 26.25 21.25 26.25H8.75C8.08696 26.25 7.45107 25.9866 6.98223 25.5178C6.51339 25.0489 6.25 24.413 6.25 23.75V15",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#B45AFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.375 10C8.5462 10 7.75134 9.67076 7.16529 9.08471C6.57924 8.49866 6.25 7.7038 6.25 6.875C6.25 6.0462 6.57924 5.25134 7.16529 4.66529C7.75134 4.07924 8.5462 3.75 9.375 3.75C10.5809 3.72899 11.7625 4.31407 12.7659 5.42895C13.7693 6.54383 14.5478 8.13675 15 10C15.4522 8.13675 16.2307 6.54383 17.2341 5.42895C18.2375 4.31407 19.4191 3.72899 20.625 3.75C21.4538 3.75 22.2487 4.07924 22.8347 4.66529C23.4208 5.25134 23.75 6.0462 23.75 6.875C23.75 7.7038 23.4208 8.49866 22.8347 9.08471C22.2487 9.67076 21.4538 10 20.625 10",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#B45AFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.9ab768d82dea73a4862f318a6ad2171e.svg";
export { ForwardRef as ReactComponent };